import moment from 'moment';
import DateUtil from '../utils/DateUtil';
/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import TSAbstractEntity from './TSAbstractEntity';
import {TSSerializable} from './TSSerializable';

export default class TSEigenleistungStundenDaten extends TSAbstractEntity implements TSSerializable<TSEigenleistungStundenDaten> {

    private _arbeitsstunden: number;

    private _betrag: number;

    private _datum: moment.Moment | undefined;

    private _deleted: boolean = false;

    public static getDeserializer = (eigenleistung: any) => {
        return new TSEigenleistungStundenDaten().deserialize(eigenleistung);
    };

    public static getSerializer = (eigenleistung: any) => {
        return eigenleistung.serialize(eigenleistung);
    };

    public get arbeitsstunden(): number {
        return this._arbeitsstunden;
    }

    public set arbeitsstunden(value: number) {
        this._arbeitsstunden = value;
    }

    public get betrag(): number {
        return this._betrag;
    }

    public set betrag(value: number) {
        this._betrag = value;
    }

    public get datum(): moment.Moment | any {
        return this._datum;
    }

    public set datum(value: moment.Moment | any) {
        this._datum = value;
    }

    public get deleted(): boolean {
        return this._deleted;
    }

    public set deleted(value: boolean) {
        this._deleted = value;
    }

    deserialize(restObject: any): TSEigenleistungStundenDaten {
        super.deserialize(restObject);

        this.arbeitsstunden = restObject.arbeitsstunden;
        this.betrag = restObject.betrag;
        this.datum = DateUtil.localDateToMoment(restObject.datum);
        this.deleted = restObject.deleted;

        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);

        restObject.arbeitsstunden = this.arbeitsstunden;
        restObject.betrag = this.betrag;
        restObject.deleted = this.deleted;
        if (this.datum) {
            restObject.datum = DateUtil.momentToLocalDate(this.datum);
        }

        return restObject;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSEigenleistungStundenDaten.ts